import { DashboardContainer } from "@/components/Dashboard/DashboardContainer.tsx";
import { useTermsAccepted } from "@/hooks/useTermsAccepted";
import { TermsDialog } from "@/components/Dialogs/TermsDialog";
import { Loading } from "@/components/Page/Loading";

const ShopDashboardPage = () => {
  const { termsAccepted, termsLoading } = useTermsAccepted();
  if (termsLoading) {
    return (
      <div className="mx-auto flex h-96 flex-grow flex-col items-center justify-center">
        <Loading />
      </div>
    );
  }
  return (
    <>
      {!termsAccepted && <TermsDialog open={true} setOpen={() => null} />}
      <DashboardContainer />
    </>
  );
};

export default ShopDashboardPage;
